/* eslint-disable max-classes-per-file */
import { ToJsonInputTranslatable } from '@src/app/model/to-json-input-translatable';
import {
  LocalizedStringForAppInput,
  LocalizedStringForAttributeInput,
  LocalizedStringForInvariantInput,
  LocalizedVariantInput,
  StringStringInputMap,
  StringStringInputPair,
  ValueStringInputMap,
  ValueStringInputPair,
  VariantTranslationKey,
} from '@src/app/generated/globalTypes';
import { JsonObject, JsonProperty } from 'ta-json';
import { GetTranslations_translations } from '@src/app/generated/GetTranslations';

@JsonObject()
export class LocalizedStringForVariant implements ToJsonInputTranslatable {
  @JsonProperty() groupId: string;
  @JsonProperty() values: VariantTranslationStringMap;

  constructor(groupId?: any, values?: VariantTranslationStringMap) {
    this.groupId = groupId;
    this.values = values;
  }

  public toGqlInput(): LocalizedVariantInput {
    return {
      groupId: this.groupId,
      values: this.values.toGqlInput(),
    };
  }
}

@JsonObject()
export class LocalizedStringForApp implements ToJsonInputTranslatable {
  @JsonProperty() values: TranslationStringMap;

  constructor(values?: TranslationStringMap) {
    this.values = values;
  }

  public toGqlInput(): LocalizedStringForAppInput {
    return {
      values: this.values.toGqlInput(),
    };
  }
}

@JsonObject()
export class LocalizedStringForInvariant implements ToJsonInputTranslatable {
  @JsonProperty() values: TranslationStringMap;

  constructor(values?: TranslationStringMap) {
    this.values = values;
  }

  public toGqlInput(): LocalizedStringForInvariantInput {
    return {
      values: this.values.toGqlInput(),
    };
  }
}

@JsonObject()
export class LocalizedStringForAttribute implements ToJsonInputTranslatable {
  @JsonProperty() values: TranslationStringMap;

  constructor(values?: TranslationStringMap) {
    this.values = values;
  }

  public toGqlInput(): LocalizedStringForAttributeInput {
    return {
      values: this.values.toGqlInput(),
    };
  }
}

export class VariantTranslationStringMap implements ToJsonInputTranslatable {
  @JsonProperty() values: VariantTranslationStringPair[];

  constructor(values?: VariantTranslationStringPair[]) {
    this.values = values;
  }

  public toGqlInput(): ValueStringInputMap {
    return {
      values: this.values.map(x => x.toGqlInput()),
    };
  }
}

export class VariantTranslationStringPair implements ToJsonInputTranslatable {
  @JsonProperty() key: VariantTranslationKey;
  @JsonProperty() value: string;

  constructor(key?: VariantTranslationKey, value?: string) {
    this.key = key;
    this.value = value;
  }

  static fromGql(gql: GetTranslations_translations): VariantTranslationStringPair {
    return new VariantTranslationStringPair(
      VariantTranslationKey[gql.key],
      gql.value
    );
  }

  public toGqlInput(): ValueStringInputPair {
    return {
      key: this.key ?? VariantTranslationKey.Title,
      value: this.value,
    };
  }
}

@JsonObject()
export class TranslationStringMap implements ToJsonInputTranslatable {
  @JsonProperty() values: TranslationStringPair[];

  constructor(values?: TranslationStringPair[]) {
    this.values = values;
  }

  public toGqlInput(): StringStringInputMap {
    return {
      values: this.values.map(x => x.toGqlInput()),
    };
  }
}

@JsonObject()
export class TranslationStringPair implements ToJsonInputTranslatable {
  @JsonProperty() key: string;
  @JsonProperty() value: string;

  constructor(key?: string, value?: string) {
    this.key = key;
    this.value = value;
  }

  static fromGql(gql: GetTranslations_translations): TranslationStringPair {
    return new TranslationStringPair(
      gql.key,
      gql.value
    );
  }

  public toGqlInput(): StringStringInputPair {
    return {
      key: this.key,
      value: this.value,
    };
  }
}
